import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _classCallCheck from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _get from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/get.js";
import _inherits from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import _possibleConstructorReturn from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.regexp.split.js";
import "core-js/modules/es6.string.starts-with.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es7.object.values.js";
import "core-js/modules/es6.array.filter.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// User Model
import VuexORM from '@vuex-orm/core';
import axios from 'axios';
import Vue from 'vue';
import Account from "./Account";
import UserIntegration from "./UserIntegration";
import Source from "./Source";
import UserSource from "./UserSource";
import Avatar from "./Avatar";
import Group from "./Group";
import GroupUser from "./GroupUser";
import Project from "./Project";
import ProjectUser from "./ProjectUser";
import Timer from "./Timer";
import Client from "./Client";
import Phase from "./Phase";
import PhaseCategory from "./PhaseCategory";
import TagList from "./TagList";
import Tag from "./Tag";
import LocalStorage from 'quasar/src/plugins/LocalStorage.js';import Notify from 'quasar/src/plugins/Notify.js';import SessionStorage from 'quasar/src/plugins/SessionStorage.js';;
import Integration from "./Integration";
import moment from 'moment';
import * as microsoftTeams from '@microsoft/teams-js';

var User = /*#__PURE__*/function (_VuexORM$Model) {
  _inherits(User, _VuexORM$Model);

  var _super = _createSuper(User);

  function User() {
    _classCallCheck(this, User);

    return _super.apply(this, arguments);
  }

  _createClass(User, [{
    key: "getReminderSettings",
    value: function getReminderSettings() {
      if (this.settings.reminderEmail) {
        return this.settings.reminderEmail;
      } else if (this.account && this.account.settings) {
        return this.account.settings.reminderEmail;
      }

      return undefined;
    }
  }, {
    key: "intermediate",
    value: function intermediate(key, entityId) {
      switch (key) {
        case 'project':
          return ProjectUser.find([entityId, this.user_id]);

        case 'user':
          return GroupUser.find([entityId, this.user_id]);

        case 'source':
          return UserSource.find([this.user_id, entityId]);

        default:
          return null;
      }
    }
  }, {
    key: "active",
    get: function get() {
      return !!this.enabled;
    }
  }, {
    key: "hasApprovalRole",
    get: function get() {
      var roles = this.account.settings.approval_roles || ['owner'];
      return this.is_owner || this.is_admin && roles.includes('admin') || this.is_gm && roles.includes('gm') || this.is_pm && roles.includes('pm');
    }
  }, {
    key: "canAccessApprovals",
    get: function get() {
      if (this.account.hasDisabledFeature('approval')) return false;
      return this.hasApprovalRole || this.is_manager && this.account.settings.approval_manager_enabled;
    }
  }], [{
    key: "entity",
    get: // This is the name used as module name of the Vuex Store.
    function get() {
      return 'users';
    }
  }, {
    key: "primaryKey",
    get: function get() {
      return 'user_id';
    }
  }, {
    key: "apiConfig",
    get: function get() {
      return {
        dataKey: 'data'
      };
    }
  }, {
    key: "insertOrUpdate",
    value: function insertOrUpdate(_ref) {
      var data = _ref.data;
      var isGroupPivotIncluded = false,
          isProjectPivotIncluded = false;

      if (Array.isArray(data)) {
        data.forEach(function (item) {
          if (item.projects && item.projects.length) {
            isProjectPivotIncluded = true;
          }

          if (item.groups && item.groups.length) {
            isGroupPivotIncluded = true;
          }
        });
        var projectPivotData = [];

        if (isProjectPivotIncluded) {
          // check if pivot table is present
          projectPivotData = data.map(function (user) {
            return user.projects.map(function (project) {
              return project.pivot;
            });
          }).flat();
        }

        var groupPivotData = [];

        if (isGroupPivotIncluded) {
          // check if pivot table is present
          groupPivotData = data.map(function (user) {
            return user.groups.map(function (group) {
              return group.pivot;
            });
          }).flat();
        }
      }

      return Promise.all([_get(_getPrototypeOf(User), "insertOrUpdate", this).call(this, {
        data: data
      }), isProjectPivotIncluded ? ProjectUser.insertOrUpdate({
        data: projectPivotData
      }) : Promise.resolve(), isGroupPivotIncluded ? GroupUser.insertOrUpdate({
        data: groupPivotData
      }) : Promise.resolve()]).then(function (results) {
        return results[0];
      });
    } // List of all fields (schema) of the post model. `this.attr` is used
    // for the generic field type. The argument is the default value.

  }, {
    key: "fields",
    value: function fields() {
      return {
        user_id: this.attr(null),
        name: this.attr(''),
        lower_name: this.attr(null),
        email: this.attr(''),
        phone_number: this.attr(''),
        company_domain: this.attr(''),
        created_date: this.attr(''),
        invited_at: this.attr(''),
        enabled: this.attr(''),
        is_admin: this.attr(''),
        is_owner: this.attr(false),
        role: this.attr(null),
        job_title: this.attr(null),
        department: this.attr(null),
        workspace_access_level: this.attr(null),
        manager_id: this.attr(null),
        is_gm: this.attr(false),
        is_pm: this.attr(false),
        is_manager: this.attr(false),
        managed_users_ids: this.attr([]),
        can_revert_v2: this.attr(false),
        user_hourly_cost: this.number(null),
        user_hourly_rate: this.number(null),
        working_time: this.number(null),
        working_hours: this.attr(null),
        projects_count: this.number(null),
        notifications: this.attr(null),
        session_last_time: this.attr(null),
        last_entry: this.attr(null),
        environment: this.attr(null),
        group_id: this.attr(null),
        client_id: this.attr(''),
        account_id: this.attr(''),
        account: this.belongsTo(Account, 'account_id', 'account_id'),
        integrations: this.belongsToMany(Integration, UserIntegration, 'user_id', 'integration_code'),
        timers: this.hasMany(Timer, 'user_id', 'user_id'),
        experiments: this.attr({}),
        avatar: this.hasOne(Avatar, 'user_id', 'user_id'),
        settings: this.attr({}),
        settings_emails_dailyrecap_enabled: this.boolean(false),
        settings_dailyemail_time: this.attr(false),
        settings_emails_status_enabled: this.boolean(false),
        settings_emails_status_time: this.attr(false),
        settings_emails_status_day: this.attr(false),
        settings_emails_automation_enabled: this.boolean(false),
        settings_emails_timerssaved_enabled: this.boolean(false),
        settings_timers_autosave_time: this.attr(null),
        setup_integrations: this.attr(null),
        setup_suggested_integration: this.attr(''),
        setup_completed: this.boolean(false),
        setup_all_completed: this.boolean(false),
        pending_setup: this.boolean(false),
        sources: this.belongsToMany(Source, UserSource, 'user_id', 'source'),
        groups: this.belongsToMany(Group, GroupUser, 'user_id', 'group_id'),
        projects: this.belongsToMany(Project, ProjectUser, 'user_id', 'project_id', 'user_id', 'project_id'),
        me: this.attr(''),
        uniq_id: this.attr(false),
        health_score: this.attr(0),
        is_google: this.attr(false),
        is_microsoft: this.attr(false),
        is_third_party: this.attr(false),
        uses_v2_reports: this.attr(false),
        hubspot_visitor_identification_token: this.attr(null),
        time_zone: this.attr(null)
      };
    }
  }, {
    key: "logins",
    get: function get() {
      return this.store().state.entities.users.users;
    }
  }, {
    key: "accessToken",
    value: function accessToken() {
      return localStorage.getItem('access_token');
    }
  }, {
    key: "setAccessToken",
    value: function setAccessToken(token) {
      localStorage.setItem('access_token', token);
      Vue.prototype.$axios.defaults.headers.common.Authorization = 'Bearer ' + token;
      Vue.prototype.$echo.options.auth.headers.Authorization = 'Bearer ' + token;
    }
  }, {
    key: "setRefreshToken",
    value: function setRefreshToken(refreshToken) {
      localStorage.setItem('refresh_token', refreshToken);
    }
  }, {
    key: "$refreshAccessToken",
    value: function $refreshAccessToken(callback) {
      var _this = this;

      var refreshToken = localStorage.getItem('refresh_token');
      this.state.waitingRequests.push(callback);

      if (this.state.refreshingToken) {
        return;
      }

      this.state.refreshingToken = true;
      return Vue.prototype.$axios.post('refresh-token', {
        refresh_token: refreshToken
      }).then(function (response) {
        var accessToken = response.data.access_token;
        var refreshToken = response.data.refresh_token;
        User.setAccessToken(accessToken);
        User.setRefreshToken(refreshToken);

        var switchingUser = _this.store().state.entities.users.switchingUser;

        if (switchingUser) {
          User.commit(function (state) {
            state.switchingUser = false;
          });
        }

        if (_this.state.waitingRequests.length) {
          _this.state.waitingRequests.forEach(function (request) {
            request.headers.Authorization = 'Bearer ' + User.accessToken();
            Vue.prototype.$axios(request).then(function (response) {
              if (request.url === '/me' && switchingUser) {
                // this is needed because when an user switch request fails with a 401 error and the token gets refreshed correctly
                // it's still catching the request failure and resetting the old access and refresh tokens.
                // In case of user switch we want to set back the new tokens just received to log in correctly the other user.
                User.setAccessToken(accessToken);
                User.setRefreshToken(refreshToken);
                window.location.reload();
              }
            }).catch(function () {});
          });

          _this.state.waitingRequests = [];
        }

        return response.data.access_token;
      }).catch(function (err) {
        console.log(err);
        Notify.create({
          color: 'warning',
          textColor: 'dark',
          timeout: 1500,
          message: 'Your session has expired.',
          onDismiss: function onDismiss() {
            // If even the refresh token is not valid, we need to logout the user only if we are not switching user.
            // If we are switching user and his refresh token is not valid it will be prompted with a new login dialog instead.
            if (!_this.store().state.entities.users.switchingUser) {
              // remove all logged user references in local storage
              localStorage.removeItem('access_token');
              localStorage.removeItem('refresh_token');
              localStorage.removeItem('users');

              if (window.location.pathname !== '/login') {
                window.location = '/login';
              }
            }

            User.commit(function (state) {
              state.switchingUser = false;
            });
          }
        });
      }).finally(function () {
        _this.state.refreshingToken = false;
      });
    }
  }, {
    key: "$login",
    value: function $login(credentials) {
      return Vue.prototype.$axios.post('/login', {
        username: credentials.email,
        password: credentials.password
      }).then(function (response) {
        if (response.data.account_exist && response.data.account_is_verified) {
          User.setAccessToken(response.data.access_token);
          User.setRefreshToken(response.data.refresh_token);
        }

        return response;
      });
    }
  }, {
    key: "getHubspotCookieToken",
    value: function getHubspotCookieToken() {
      var cookie = document.cookie.split('; ').find(function (row) {
        return row.startsWith('hubspotutk=');
      });

      if (cookie) {
        var regex = /hubspotutk=([\s\S]*)/;
        var m;

        if ((m = regex.exec(cookie)) !== null) {
          return m[1];
        }

        return '';
      }

      return '';
    }
  }, {
    key: "getRewardfulReferrerData",
    value: function getRewardfulReferrerData() {
      var _window$Rewardful$aff, _window$Rewardful$cam, _window$Rewardful$aff2;

      if (!window.Rewardful) return {};
      var Affiliate = (_window$Rewardful$aff = window.Rewardful.affiliate) === null || _window$Rewardful$aff === void 0 ? void 0 : _window$Rewardful$aff.name;
      var Campaign = (_window$Rewardful$cam = window.Rewardful.campaign) === null || _window$Rewardful$cam === void 0 ? void 0 : _window$Rewardful$cam.name;
      var Link = (_window$Rewardful$aff2 = window.Rewardful.affiliate) === null || _window$Rewardful$aff2 === void 0 ? void 0 : _window$Rewardful$aff2.token;
      var referral = window.Rewardful.referral;

      if (referral) {
        return {
          affiliate_data: {
            Affiliate: Affiliate,
            Campaign: Campaign,
            Link: Link,
            referral: referral
          }
        };
      }

      return {};
    }
  }, {
    key: "$signup",
    value: function $signup(signupData) {
      return Vue.prototype.$axios.post('/signup', _objectSpread(_objectSpread(_objectSpread({}, signupData), User.getRewardfulReferrerData()), {}, {
        hubspotCookie: this.getHubspotCookieToken(),
        teCookieUUID: window.Timelytics.getTeUniqueId()
      })); // .then((response) => {
      //   User.setAccessToken(response.data.access_token)
      //   User.setRefreshToken(response.data.refresh_token)
      // })
    }
  }, {
    key: "$validateEmail",
    value: function $validateEmail(validationData) {
      return Vue.prototype.$axios.post('/validate-email', _objectSpread({}, validationData)).then(function (response) {
        User.setAccessToken(response.data.access_token);
        User.setRefreshToken(response.data.refresh_token);
      });
    }
  }, {
    key: "$loginWithSetupToken",
    value: function $loginWithSetupToken(token) {
      return Vue.prototype.$axios.post("/login/setup-token/".concat(token)).then(function (response) {
        User.setAccessToken(response.data.access_token);
        User.setRefreshToken(response.data.refresh_token);
      });
    }
  }, {
    key: "$loginWithUniqToken",
    value: function $loginWithUniqToken(token) {
      return Vue.prototype.$axios.post("/login/uniq-token/".concat(token)).then(function (response) {
        User.setAccessToken(response.data.access_token);
        User.setRefreshToken(response.data.refresh_token);
      });
    }
  }, {
    key: "$ssoLogin",
    value: function $ssoLogin(credentials) {
      return Vue.prototype.$axios.post('/login/sso', {
        email: credentials.email
      });
    }
  }, {
    key: "$microsoftTeamsSSO",
    value: function $microsoftTeamsSSO(token) {
      return Vue.prototype.$axios.post('/login/teams-sso', {
        token: token
      }, {
        headers: {
          'X-AvoidNotification': true
        }
      }).then(function (response) {
        if (response.data.error) {
          return microsoftTeams.authentication.authenticate({
            url: process.env.APP_URI + '/teams/auth/microsoft',
            width: 1300,
            height: 535,
            isExternal: false
          }).then(function () {
            return User.$microsoftTeamsSSO(token);
          });
        }

        return response;
      }).catch(function (e) {
        return false;
      });
    }
  }, {
    key: "$thirdPartyLoginWithToken",
    value: function $thirdPartyLoginWithToken(service, data) {
      var _this2 = this;

      return Vue.prototype.$axios.post("/login/".concat(service), {
        token: data.token
      }, {
        headers: {
          'X-AvoidNotification': true
        }
      }).then(function (response) {
        User.setAccessToken(response.data.access_token);
        User.setRefreshToken(response.data.refresh_token);
        return {
          new_user: false,
          is_company: !!response.data.is_company,
          service: service
        };
      }).catch(function (e) {
        if (data.skipSignUp) {
          throw e;
        } // Social user not found,
        // Create a new one


        return Vue.prototype.$axios.post('/login/' + service + '/authorize', _objectSpread({
          token: data.token,
          hubspotCookie: _this2.getHubspotCookieToken(),
          teCookieUUID: window.Timelytics.getTeUniqueId(),
          ga_client_id: data.ga_client_id || '',
          is_ms_teams: !!data.isMsTeams,
          skip_company_check: data.skip_company_check,
          signup: data.signup
        }, User.getRewardfulReferrerData())).then(function (response) {
          User.setAccessToken(response.data.access_token);
          User.setRefreshToken(response.data.refresh_token);
          return {
            new_user: true,
            is_company: !!response.data.is_company,
            service: service
          };
        });
      });
    }
  }, {
    key: "$requestEmailUpdate",
    value: function $requestEmailUpdate(email) {
      return Vue.prototype.$axios.put('/me/email', {
        email: email
      });
    }
  }, {
    key: "$confirmEmailUpdate",
    value: function $confirmEmailUpdate(code) {
      return Vue.prototype.$axios.post('/me/email-confirm', {
        code: code
      }).then(function (response) {
        User.update({
          where: function where(user) {
            return user.me;
          },
          data: {
            email: response.data.email
          }
        });
        User.commit(function (state) {
          state.me = User.query().withAll().with(['account.avatar', 'account.subscription_type']).where('me', true).first();
        });
        return Promise.resolve(response);
      });
    }
  }, {
    key: "insertOrUpdateLogin",
    value: function insertOrUpdateLogin(user) {
      var _this3 = this;

      return User.commit(function (state) {
        var users = _this3.logins;
        users[user.user_id] = {
          user_id: user.user_id,
          email: user.email,
          name: user.name,
          avatar: user.avatar,
          access_token: localStorage.getItem('access_token'),
          refresh_token: localStorage.getItem('refresh_token')
        };
        state.users = _objectSpread({}, users);
        localStorage.setItem('users', JSON.stringify(users));
      });
    }
  }, {
    key: "$switchUser",
    value: function $switchUser(userId) {
      var myUser = this.logins[userId];

      if (myUser) {
        // Save current access and refresh tokens in case of failure during the user switch
        var oldAccessToken = localStorage.getItem('access_token');
        var oldRefreshToken = localStorage.getItem('refresh_token'); // Set new user access and refresh tokens and try to retrieve the user

        User.setRefreshToken(myUser.refresh_token);
        User.setAccessToken(myUser.access_token);
        User.commit(function (state) {
          state.switchingUser = true;
        });
        return User.$me().then(function () {
          // clear the sessionStorage
          SessionStorage.clear(); // clear the localStorage of particular keys

          LocalStorage.remove('todo-management-tab');
          LocalStorage.remove('todo-management-todo-list-id');
          LocalStorage.remove('todo-management-project-id');
          LocalStorage.remove('dashboard-todos-tab');
          LocalStorage.remove('dashboard-todos-todo-list-id');
          LocalStorage.remove('dashboard-todos-project-id'); // refresh page to reset store and all new user abridged data

          window.location.reload();
        }).catch(function (error) {
          // if it fails restore old access and refresh token
          User.setAccessToken(oldAccessToken);
          User.setRefreshToken(oldRefreshToken);
          return Promise.reject(error);
        });
      } else {
        return Promise.resolve();
      }
    }
  }, {
    key: "$inviteUsers",
    value: function $inviteUsers(users) {
      return Vue.prototype.$axios.post('/users/invite', {
        account_id: this.account_id,
        users: users
      });
    }
  }, {
    key: "$delete",
    value: function $delete(id) {
      return Vue.prototype.$axios.post('/users/' + id + '/delete');
    }
  }, {
    key: "$deactivate",
    value: function $deactivate(users) {
      return Vue.prototype.$axios.post('/users/deactivate', {
        users: users
      }).then(function () {
        User.update({
          where: function where(user) {
            return !!users.find(function (u) {
              return u.user_id === user.user_id;
            });
          },
          data: {
            enabled: 0,
            auth_token: '',
            push_system: '',
            push_token: '',
            cookie_token: ''
          }
        });
      });
    }
  }, {
    key: "$activate",
    value: function $activate(users) {
      return Vue.prototype.$axios.post('/users/activate', {
        users: users
      }).then(function () {
        User.update({
          where: function where(user) {
            return !!users.find(function (u) {
              return u.user_id === user.user_id;
            });
          },
          data: {
            enabled: 1
          }
        });
      });
    }
  }, {
    key: "clearUserDataFromStorage",
    value: function clearUserDataFromStorage() {
      // keep canny changelog seen status if present to avoid showing it again after logout
      var cannyChangelogSeen = localStorage.getItem('canny-changelog-seen');
      localStorage.clear();

      if (cannyChangelogSeen) {
        localStorage.setItem('canny-changelog-seen', cannyChangelogSeen);
      }

      SessionStorage.clear();
    }
  }, {
    key: "$logout",
    value: function $logout(user) {
      var _this4 = this;

      var redirectToLogin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;
      var requests = []; // logout single user if passed or all logged users

      var logins = user ? [user] : Object.values(this.logins);
      logins.forEach(function (login) {
        var accessToken = login.access_token;

        if (accessToken) {
          requests.push(axios.post('/logout', {}, {
            baseURL: process.env.API_URL,
            headers: {
              Authorization: 'Bearer ' + accessToken
            }
          }));
        }
      });
      return Promise.all(requests).finally(function (results) {
        User.commit(function (state) {
          state.lastLogoutAt = Date.now();
        });

        if (user) {
          User.commit(function (state) {
            var users = state.users;
            delete users[user.user_id];
            state.users = _objectSpread({}, users);
            localStorage.setItem('users', JSON.stringify(users));
          });
        } else {
          // if i'm logging out all users, clear the local storage and the session storage
          if (redirectToLogin) {
            var isMicrosoftTeams = _this4.store().state.app.microsoftTeams.isInitialized;

            setTimeout(function () {
              _this4.clearUserDataFromStorage();

              window.location = '/login' + (isMicrosoftTeams ? '?force_login=false' : '');
            }, timeout);
          } else {
            _this4.clearUserDataFromStorage();

            _this4.store().dispatch('entities/deleteAll');

            User.commit(function (state) {
              state.me = null;
              state.users = {};
            });
          }
        }
      });
    }
  }, {
    key: "$sendResetPassword",
    value: function $sendResetPassword(data) {
      return Vue.prototype.$axios.post('/password/send-reset/', data).catch(function () {});
    }
  }, {
    key: "$resetPassword",
    value: function $resetPassword(_ref2) {
      var token = _ref2.token,
          password = _ref2.password,
          passwordConfirmation = _ref2.passwordConfirmation;
      return Vue.prototype.$axios.post('/password/reset/' + token, {
        password: password,
        password_confirmation: passwordConfirmation
      });
    }
  }, {
    key: "$me",
    value: function $me() {
      var _this5 = this;

      return Vue.prototype.$axios.get('/me').then(function (response) {
        Group.commit(function (state) {
          state.count = response.data.account.groups_count;
        });
        User.commit(function (state) {
          state.count = response.data.account.users_count;
        });
        Client.commit(function (state) {
          state.count = response.data.account.clients_count;
        });
        Project.commit(function (state) {
          state.count = response.data.account.projects_count;
        });
        Phase.commit(function (state) {
          state.count = response.data.account.phases_count;
        });
        PhaseCategory.commit(function (state) {
          state.count = response.data.account.phase_categories_count;
        });
        TagList.commit(function (state) {
          state.count = response.data.account.tag_lists_count;
        });
        Tag.commit(function (state) {
          state.count = response.data.account.tags_count;
        });

        _this5.setMe(response.data);
      });
    }
  }, {
    key: "setMe",
    value: function setMe(user) {
      return User.insertOrUpdate({
        data: [user]
      }).then(function () {
        return User.commit(function (state) {
          var me = User.query().withAll().with(['account.avatar', 'account.subscription_type']).where('user_id', user.user_id).first();
          state.me = _objectSpread({}, me);
          state.switchingUser = false;

          if (me) {
            // every time the logged user is updated we should update the logins list in the storage to show correct
            // data in the user switch dialog.
            return User.insertOrUpdateLogin(me);
          }
        });
      });
    }
  }, {
    key: "$updateMe",
    value: function $updateMe(data) {
      return Vue.prototype.$axios.put('/me', data).then(function (response) {
        return User.insertOrUpdate({
          data: [response.data]
        }).then(function () {
          return User.commit(function (state) {
            state.me = User.query().withAll().with(['account.avatar', 'account.subscription_type']).where('me', true).first();
          });
        });
      });
    }
  }, {
    key: "$getPersonalAccessTokens",
    value: function $getPersonalAccessTokens() {
      return Vue.prototype.$axios.get('/me/personal-access-tokens');
    }
  }, {
    key: "$issuePersonalAccessToken",
    value: function $issuePersonalAccessToken(params) {
      return Vue.prototype.$axios.post('/me/personal-access-tokens', params);
    }
  }, {
    key: "$revokeAccessToken",
    value: function $revokeAccessToken(token) {
      return Vue.prototype.$axios.delete('/me/personal-access-tokens/' + token.id);
    }
  }, {
    key: "$deleteDemoData",
    value: function $deleteDemoData(id) {
      return Vue.prototype.$axios.post('/users/' + id + '/delete-demo-data');
    }
  }, {
    key: "refreshMe",
    value: function refreshMe() {
      User.commit(function (state) {
        state.me = User.query().withAll().with(['account.avatar', 'account.subscription_type']).where('me', true).first();
      });
    }
  }, {
    key: "getWorkingDays",
    value: function getWorkingDays(user) {
      if (user.working_hours) {
        return user.working_hours;
      } else if (User.me().account && User.me().account.settings && User.me().account.settings.working_hours) {
        return User.me().account.settings.working_hours;
      }

      return undefined;
    }
  }, {
    key: "getWeekendDays",
    value: function getWeekendDays(user) {
      var _this6 = this;

      var weekDays = [0, 1, 2, 3, 4, 5, 6];
      return weekDays.filter(function (day) {
        var _this6$getWorkingDays;

        return !((_this6$getWorkingDays = _this6.getWorkingDays(user)) !== null && _this6$getWorkingDays !== void 0 && _this6$getWorkingDays.map(function (day) {
          return day.value;
        }).includes(day));
      });
    }
  }, {
    key: "getWorkingHoursDayTotal",
    value: function getWorkingHoursDayTotal(date, userId) {
      var workingHours = this.getWorkingDays(User.find(userId));

      if (workingHours) {
        var day = date.getDay();
        var dayWorkingHours = workingHours.find(function (slot) {
          return slot.value === day;
        });

        if (dayWorkingHours) {
          return dayWorkingHours.slots.reduce(function (acc, slot) {
            var start = moment(slot.start, 'HH:mm');
            var end = moment(slot.end, 'HH:mm');
            return acc + end.diff(start, 'minutes');
          }, 0);
        }
      }

      return 0;
    }
  }, {
    key: "me",
    value: function me() {
      if (!this.state.me) {
        // trick to not be stuck in the login process; we immediately set a default state if it's null and then we make a
        // synchronous change so that we can get an actual observer of the entity instead of a static dead object that will
        // never change
        this.state.me = User.query().withAll().with(['account.avatar', 'account.subscription_type']).where('me', true).first();
        User.commit(function (state) {
          state.me = User.query().withAll().with(['account.avatar', 'account.subscription_type']).where('me', true).first();
        });
      }

      return this.state.me;
    }
  }, {
    key: "unreadNotificationsCount",
    value: function unreadNotificationsCount() {
      return Notification.query().whereNotNull('read_at').where('notifiable_id', User.me().user_id).where('notifiable_type', "App\\User").count();
    }
  }, {
    key: "lastLogoutAt",
    get: function get() {
      return this.store().state.entities.users.lastLogoutAt;
    }
  }]);

  return User;
}(VuexORM.Model);

_defineProperty(User, "state", {
  me: null,
  users: JSON.parse(localStorage.getItem('users')) || {},
  switchingUser: false,
  refreshingToken: false,
  waitingRequests: [],
  pending: false,
  lastSync: null,
  lastLogoutAt: null,
  count: 0
});

export { User as default };